import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
} from "@mui/material";
import { TabContext, TabPanel } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";

import { ApplicationState } from "../../store";
import {
    loadRequest,
    releaseCheckinRequest,
} from "../../store/ducks/checkin/actions";
import { CheckinReleaseList } from "../../store/ducks/checkin/types";
import FacebookCircularProgress from "../../components/Loading";

const CheckinRelease: React.FC = () => {

    const [tabValue] = useState("0");
    const [openConfirm, setOpenConfirm] = useState(false);
    const [selectedRow, setSelectedRow] =
        useState<CheckinReleaseList | null>(null);
    const [observation, setObservation] = useState("");

    const dispatch = useDispatch();
    const { data, loading } = useSelector(
        (state: ApplicationState) => state.checkinRelease
    );

    useEffect(() => {
        dispatch(
            loadRequest({
                limit: 10,
                page: 1,
            })
        );
    }, [dispatch]);

    const handleOpenConfirm = (row: CheckinReleaseList) => {
        setSelectedRow(row);
        setOpenConfirm(true);
    };

    const handleCloseConfirm = () => {
        setOpenConfirm(false);
        setSelectedRow(null);
        setObservation("");
    };

    const handleConfirmRelease = () => {
        if (!selectedRow) return;

        dispatch(
            releaseCheckinRequest({
                id: selectedRow._id,
                observation: observation || null,
            })
        );

        handleCloseConfirm();
    };

    return (
        <Box>
            <TabContext value={tabValue}>
                <TabPanel value="0" sx={{ p: 0 }}>
                    <TableContainer component={Paper} elevation={0}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Atendimento</TableCell>
                                    <TableCell>Paciente</TableCell>
                                    <TableCell>Check-in</TableCell>
                                    <TableCell />
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {loading && (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center">
                                            <FacebookCircularProgress />
                                        </TableCell>
                                    </TableRow>
                                )}

                                {!loading && data?.length > 0 && data.map((row) => (
                                    <TableRow key={row._id}>
                                        <TableCell>{row.external_attendance_id}</TableCell>
                                        <TableCell>{row.patient_id.name}</TableCell>
                                        <TableCell>{row.created_at}</TableCell>
                                        <TableCell>
                                            <Button
                                                variant="contained"
                                                size="small"
                                                onClick={(e) => {
                                                    e.currentTarget.blur();
                                                    handleOpenConfirm(row);
                                                }}
                                            >
                                                Liberar
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}

                                {!loading && data?.length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center">
                                            Nenhum dado encontrado
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>
            </TabContext>

            <Dialog
                open={openConfirm}
                onClose={handleCloseConfirm}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Liberação de Check-in</DialogTitle>

                <DialogContent>
                    <DialogContentText sx={{ mb: 2 }}>
                        Tem certeza que deseja liberar o check-in do atendimento{" "}
                        <strong>{selectedRow?.external_attendance_id}</strong>, paciente{" "}
                        <strong>{selectedRow?.patient_id.name}</strong>?
                    </DialogContentText>

                    <TextField
                        label="Observação (opcional)"
                        placeholder="Digite uma observação, se necessário"
                        fullWidth
                        multiline
                        minRows={3}
                        value={observation}
                        onChange={(e) => setObservation(e.target.value)}
                    />
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleCloseConfirm}>
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleConfirmRelease}
                    >
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default CheckinRelease;
